<template>
  <power-bi code="eyJrIjoiMGI2YzE3MjItNjYwOC00M2I4LTk3ZWMtNzcwNDYwZTkwOWVmIiwidCI6ImM4NDJjMWQ5LWQzNjQtNDcxNi1iN2UzLWNhNDgxYTIzZDZhYyJ9" />
</template>

<script>
import PowerBi from '../components/PowerBi.vue';

export default {
    components: {
        PowerBi,
    },
};
</script>
